import { HttpWrapper } from '@/shared/services/rest.service';
import * as endpoints from './endpoints';

export default {
    lookupAddress(address, state) {
        return HttpWrapper.get(`${endpoints.UTILITY}/lookupAddress?address=${address}&state=${state}`);
    },
}